import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ReservaPadel from './ReservaPadel';
import { HashRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <ReservaPadel />
  </HashRouter>
);